export default __webpack_public_path__ + "static/media/Private_Equity_20230207.a2c77541.pdf";